<div>
  <mat-card appearance="outlined" class="z-depth">
    <mat-card-title>
      <span *ngIf="organisation | async; let org; else noorg" i18n>
        Please log in to {{ org.name }}
      </span>
      <ng-template #noorg i18n>
        Please log in
      </ng-template>
    </mat-card-title>

    <mat-divider></mat-divider>

    <mat-card-content>
      <mat-list>
        <mat-list-item>
          <button mat-button (click)="login()" i18n>Login</button>
        </mat-list-item>
         <mat-list-item>
          <button mat-button (click)="resetOrganisation()" i18n>Reset organisation</button>
        </mat-list-item>
      </mat-list>
    </mat-card-content>
  </mat-card>
</div>
